import './Growth.scss'
import LeftGrowth from './Growth/LeftGrowth'
import RightGrowth from './Growth/RightGrowth'

export default function Growth() {
  return (
    <>
      <div className='gEJNLJusyz'>
        <div className='bTTTdDttfI'>
          <LeftGrowth />
        </div>
      </div>
      <div className='bzqqvrjqbh'>
        <div className='bousxmsfzt'>
          <RightGrowth />
        </div>
      </div>
    </>
  )
}